import { render, staticRenderFns } from "./OrganSealEdit.vue?vue&type=template&id=d0f690ba&scoped=true"
import script from "./OrganSealEdit.vue?vue&type=script&lang=js"
export * from "./OrganSealEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f690ba",
  null
  
)

export default component.exports